<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense color="amber darken-3")
          v-icon.white--text fa-cogs
          v-toolbar-title.white--text {{$t('order.arranged')}}
    v-layout(row wrap)
      v-flex(xs12 sm6 md4)
        v-text-field.ma-0(
          placeholder="検索: 見積番号/営業担当/業務担当/顧客担当"
          hide-details
          color="info"
          type="text"
          v-model="keyword"
          autocapitalize="off"
          prepend-icon="search"
        )
    v-btn(
      raised
      :disabled="!outputSelectedCount"
      color="primary"
      @click.stop="outputCsv"
    )
      v-icon file_download
      v-badge(color="deep-orange")
        span(slot="badge" v-if="outputSelectedCount > 0") {{outputSelectedCount}}
        span.selected-badge {{$t('list.arranged.output_csv')}}

    transition-group(name="flip-list" tag="div" class="layout row wrap")
      div.flex.xs12.sm6.md4.lg3.flip-list-item(v-for="order in filteredList" :key="order.token")
        list-item(
          :token="order.token"
          :requested="false"
          :estimated="false"
          :settled="false"
          :arranged="true"
          :completed="false"
          :search="{ enabled: false, color: 'amber darken-3', status: $t('order.arranged')}"
        )
    div#download-csv-frame(style="display: none;")
</template>

<script>
import ListItem from '../Components/ListItem'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ListItem
  },
  data () {
    return {
      keyword: ''
    }
  },
  created () {
    this.clearList()
    this.$ajax.get('order/arranged').then(response => {
      this.setList(response.data.list)
    })
  },
  beforeDestroy () {
    this.clearList()
  },
  computed: {
    ...mapGetters('app/list', [
      'list',
      'outputSelectedCount',
      'selectedTokenList'
    ]),
    filteredList () {
      const search = this.keyword || ''
      const searches = search.split(' ').map(v => new RegExp(v))
      return this.list.filter(order => {
        const searchText = [
          ...new Set([order.id + '', (order.tags || '').split(' ')])
        ]
        return searches.map(v => v.test(searchText)).every(v => v)
      })
    }
  },
  methods: {
    ...mapActions('app/list', ['clearList', 'setList', 'hideSelected']),
    outputCsv () {
      let main = document.getElementById('download-csv-frame')
      while (main.firstChild) {
        main.removeChild(main.firstChild)
      }
      this.$ajax
        .post('order/output_csv', this.selectedTokenList)
        .then(response => {
          response.data.filepaths.forEach(filepath => {
            let encoded = encodeURIComponent(filepath)
            let src =
              process.env.APP_API_URL + `/order/csv_file.csv?q=${encoded}`
            let frame = document.createElement('iframe')
            frame.setAttribute('src', src)
            main.appendChild(frame)
          })
          this.hideSelected()
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.flip-list-item {
  transition: transform 0.5s;
}

.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
}

.flip-list-leave-active {
  position: absolute;
}

.selected-badge:after {
  right: -40px;
  width: 34px;
  height: 34px;
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/List/Arranged/index.vue